export const SERVICE_TYPE_ID_ROUTE_PARAM = 'serviceTypeId';
export const VISIT_TYPE_ID_ROUTE_PARAM = 'visitTypeId';
export const PAGE_ROUTE_PARAM = 'page';
export const ID_PARAM = 'id';
